module.exports = __webpack_public_path__ + "c8af6ba20060a247d68e004bb2c6adf4.png";